import React, {useState} from 'react';
import s from './styles.module.css';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import {Box, Button, Modal} from "@mui/material";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 4,
    borderRadius: '3px',
    maxWidth: '90%',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto'
};

const ModalElement = ({isOpenModal, setIsOpenModal, onClose, resetTimers}) => {

    return (
        <Modal
            sx={{
                overflow: 'auto'
            }}
            open={isOpenModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <h1 className={s.title} style={{margin: '100px'}}>Сбросить значения секундомеров?</h1>

                <div className={s.btns}>
                    <Button variant="outlined" color="error" onClick={onClose}>
                        <CloseIcon sx={{fontSize: 40}}/>
                    </Button>
                    <Button variant="contained" onClick={() => {
                        setIsOpenModal(false);
                        resetTimers();
                    }} sx={{
                        marginLeft: '100px'
                    }}>
                        <CheckIcon sx={{fontSize: 40}}/>
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};

export default ModalElement;
